module.exports = __webpack_public_path__ + "static/media/attendance-report-viewed-video.46a54fed.svg";